import { Spacer, Text } from '@sparemin/blockhead';
import React from 'react';
import { block } from './utils';

export type CTAButtonContainerProps = {
  children?: React.ReactNode;
  title: string;
};

const CTAContainer: React.FC<CTAButtonContainerProps> = ({
  children,
  title,
}) => (
  <Spacer
    space="12px"
    className={block('cta-container')}
    orientation="vertical"
    justify="center"
  >
    <Text variant="button">{title}</Text>
    {children}
  </Spacer>
);

export default CTAContainer;
